export default () => {
  const billing_checkbox = document.querySelector('#billing_business')
  const billing_company_field = document.querySelector('#billing_company_field')
  const woocommerce_eu_vat_number_field = document.querySelector('#woocommerce_eu_vat_number_field')
    
  if (billing_checkbox && billing_company_field) {
    billing_checkbox.addEventListener('click', () => {
      if (billing_checkbox.checked === true) {
        if (billing_company_field) {
          billing_company_field.classList.add('show-business')
        }
        if (woocommerce_eu_vat_number_field) {
          woocommerce_eu_vat_number_field.classList.add('show-business')
        }
      } else {
        if (billing_company_field.classList.contains('show-business')) {
          billing_company_field.classList.remove('show-business')
        }
        if (woocommerce_eu_vat_number_field) {
          if (woocommerce_eu_vat_number_field.classList.contains('show-business')) {
            woocommerce_eu_vat_number_field.classList.remove('show-business')
          }
        }
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/modules/CheckoutBusiness.js